import React from 'react';
import { IonButton, IonContent, IonInput, IonPage, IonToast, IonHeader, IonToolbar, IonTitle, IonButtons, IonBackButton, IonCard, IonCardContent, IonItem, IonLabel } from "@ionic/react";
import authStore from '../../store/auth';
import { observer } from "mobx-react";

const ChangePassword: React.FC = observer(() => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/home" />
                    </IonButtons>
                    <IonTitle>Ganti Password</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen>
                <div style={{ backgroundColor: '#F6F8FC', padding: '15px', minHeight: '100vh' }}>
                    <IonCard>
                        <IonCardContent>
                            <div style={{ marginBottom: 20 }}>
                                <IonItem>
                                    <IonLabel position="stacked">Password Lama</IonLabel>
                                    <IonInput
                                        type="password"
                                        placeholder="Masukkan password lama"
                                        value={authStore.old_password}
                                        onIonInput={(e: any) => authStore.old_password = e.target.value}
                                        fill="outline"
                                    />
                                </IonItem>
                            </div>

                            <div style={{ marginBottom: 20 }}>
                                <IonItem>
                                    <IonLabel position="stacked">Password Baru</IonLabel>
                                    <IonInput
                                        type="password"
                                        placeholder="Masukkan password baru"
                                        value={authStore.new_password}
                                        onIonInput={(e: any) => authStore.new_password = e.target.value}
                                        fill="outline"
                                    />
                                </IonItem>
                            </div>

                            <div style={{ marginBottom: 30 }}>
                                <IonItem>
                                    <IonLabel position="stacked">Konfirmasi Password Baru</IonLabel>
                                    <IonInput
                                        type="password"
                                        placeholder="Konfirmasi password baru"
                                        value={authStore.confirm_password}
                                        onIonInput={(e: any) => authStore.confirm_password = e.target.value}
                                        fill="outline"
                                    />
                                </IonItem>
                            </div>

                            <IonButton 
                                expand="block" 
                                color="primary" 
                                onClick={() => authStore.changePassword()}
                                disabled={authStore.loading}
                            >
                                {authStore.loading ? 'Mengubah Password...' : 'Ganti Password'}
                            </IonButton>
                        </IonCardContent>
                    </IonCard>
                </div>

                <IonToast
                    isOpen={authStore.success_change_password_toggle}
                    message="Password berhasil diubah!"
                    onDidDismiss={() => authStore.setSuccessChangePasswordToggle(false)}
                    duration={3000}
                    position="top"
                    color="success"
                />

                <IonToast
                    isOpen={authStore.failed_change_password_toggle}
                    message={authStore.change_password_error || "Gagal mengubah password!"}
                    onDidDismiss={() => authStore.setFailedChangePasswordToggle(false)}
                    duration={3000}
                    position="top"
                    color="danger"
                />
            </IonContent>
        </IonPage>
    );
});

export default ChangePassword;